export const environment = {
  production: true,
  prefix:'prod_',
  firebaseConfig : {
    projectId:"afrimart-fb9f8",
    appId:"1:134224577769:web:bba9790f79f3e33e195c78",
    storageBucket:"afrimart-fb9f8.appspot.com",
    locationId:"us-central",
    apiKey:"AIzaSyAiQ27BV84MVizkFgnveTV9xzPgYCEVjIQ",
    authDomain:"afrimart-fb9f8.firebaseapp.com",
    messagingSenderId:"134224577769",
    measurementId:"G-5B4839FX0E"
  },
  api:'https://ruecart-ca-global-ms-134224577769.us-central1.run.app/',
  clientApi:"https://ruecart-ng-client-332723148698.us-central1.run.app/",
  storeLink:"https://ruecart.com/store/",
  mapKey:"AIzaSyBEW60pBY3MX5t_DmXBo3NjEX5geXrsBkk",
  collections:{
    VENDOR: 'vendor',  // Collection for vendor
    PRODUCTS: 'products',  // Collection for product
    SERVICES: 'services',  //Collection for services

    CLIENT:'client',      //Collection for client user
    VENDOR_ORDER:'vendor_order',     //Collection for vendor order
    VENDOR_SERVICE_ORDER:'vendor_service_order',
    ADMIN_USERS:'admin_user',
     ADMIN_RECORD:'admin_record',
     VENDOR_USERS:'vendor_user',

  },
  endpoints:{
    VENDOR: 'vendor',  // endpoint for vendor
    VENDOR_STATUS: 'vendor/status',  // endpoint for vendor status change
    ACTIVATE_SUBSCRIPTION:'subscription/activateSubscription',  //endpoint for activating subscription
    DEACTIVATE_SUBSCRIPTION:'subscription/deactivateSubscription', //endpoint for deactivating subscription
    UPDATE_PRODUCT_FINANCING_STATUS: 'financing/updateFinancingStatus',
    UPDATE_VENDOR_FINANCING_STATUS: 'financing/update-vendor-financing-status',
    UPDATE_VENDOR_CONFIGURATION: 'configurations',
    LOAN_CONFIGURATION:'configurations/baines-loan-calculator',
    UPDATES:'approval/updates',
    CHECK_EMAIL:'user/check-email',
    CREATE_ADMIN_USER:'user/create-admin_user',
    UPDATE_USER_PERMISSION:'user/update-user-permissions',
    CHANGE_ADMIN_STATUS:'user/change-admin-status',
    UPDATE_VENDOR_LOAN_CONFIG_STATUS:'financing/update-loan-config-status',
    TOKEN:'token',
    UPDATE_USER_PASSWORD:'user/reset-password',
    REPORTS:'report',
    ADVERT:'adverts'





  },
  documents:{
    STATISTICS:'statistics',   //Document name for statistics in ADMIN_RECORD
  }
};
